import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { Container, Button, Progress, Spinner } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { Link, useHistory, Redirect } from "react-router-dom"
import "./penilaian-shared.css";
import apiResponse from '../../../../../services/apiResponse'
import PenialianBloc from "../Blocs/PenilaianBloc"
import { ConfirmAlert } from "../../../../../helpers/ui/alert";
import moment from "moment"
import 'moment/locale/id'

// ---------- Static config ----------
// ScaleValue: 1 | 2 | 3 | 4 | 5

const SCALE_OPTIONS = [
  { value: 1, label: "Tidak Pernah", short: "Tidak" },
  { value: 2, label: "Jarang", short: "Jarang" },
  { value: 3, label: "Kadang - Kadang", short: "Kadang-Kadang" },
  { value: 4, label: "Sering", short: "Sering" },
  { value: 5, label: "Selalu", short: "Selalu" },
];

// Tailwind's rose/orange/amber/teal/emerald palettes, resolved to hex
// since plain reactstrap has no matching utility classes.
const SCALE_STYLES = {
  1: { dot: "#f43f5e", text: "#e11d48", bg: "#fff1f2", border: "#fda4af" },
  2: { dot: "#f97316", text: "#ea580c", bg: "#fff7ed", border: "#fdba74" },
  3: { dot: "#f59e0b", text: "#d97706", bg: "#fffbeb", border: "#fcd34d" },
  4: { dot: "#14b8a6", text: "#0d9488", bg: "#f0fdfa", border: "#5eead4" },
  5: { dot: "#10b981", text: "#059669", bg: "#ecfdf5", border: "#6ee7b7" },
};



class PenialianPegawaiDetailComponent extends Component {

  penialianBloc = new PenialianBloc()

  constructor(props) {
    super(props);

    this.state = {
      loadingTemp: false,
      currentStep: 0,
      canSubmit: false,
      competence_uuid: '',
      steps: [],
      groups: [],
      questions: [],
      categories: [],
      total_question: 0,
      period: {},
      member: {},
      evaluator: {},
      evaluatee: {},
      loadingContent: true,
      redirectBack: false,
      activeTab: "", // "BERAKHLAK" | "MANSOSKUL"
      importLoading: false,
    };

    this.handleBack = this.handleBack.bind(this);
    this.handleSend = this.handleSend.bind(this);
  }

  // ---------- Derived values (Svelte `$:` reactive statements) ----------
  get answeredCount() {
    return this.state.questions.filter((q) => parseInt(q.answer) !== 0).length;
  }

  get progressPct() {
    const result = Math.round((this.answeredCount / this.state.total_question) * 100);
    return result;
  }

  // ---------- Actions ----------
  selectAnswer = async (questionId, value) => {

    if(this.state.canSubmit){

      // this.setState((prev) => ({
      //   questions: prev.questions.map((q) => (q.id === questionId ? { ...q, answer: value } : q)),
      // }));

      // const question = this.state.questions.find(question => question.id === questionId);
      // const formData = new FormData();

      // formData.append("uuid", questionId);
      // formData.append("question_value", value);
      // formData.append("member_uuid", this.state.member?.ms360_team_member_uuid);
      // formData.append("question_uuid", question?.question_uuid);
      // formData.append("evaluator_uuid", this.state.evaluator?.employee_uuid);
      // formData.append("period_uuid", this.state.period?.ms360_period_uuid);
      // await this.penialianBloc.fetchSubmitDraft(formData)

    }

     this.setState(
        (prev) => ({
          questions: prev.questions.map((q) =>
            q.id === questionId ? { ...q, answer: value } : q
          ),
        }),
        () => {
          const storageKey = `session-${this.state.member?.ms360_team_member_uuid}`;
          const currentQuestions = this.state.questions;

          localStorage.setItem(storageKey, JSON.stringify(currentQuestions));
        }
      );
   
  };

  setTab = (tab) => {
    const question = this.state.questions.find((x)=> x.type_name === tab)
    this.setState({ 
      activeTab: tab,
      currentStep: 0,
      competence_uuid: question?.competence_uuid
    });
  };

  setSidebar = (com_uuid, step, tab) => {
    this.setState({ 
      activeTab: tab,
      currentStep: step,
      competence_uuid: com_uuid
    });
  }

  handleBack(e) {
    this.setState({
        redirectBack: true
    })
  }

  handleSend(e) {
    if (e && e.preventDefault) e.preventDefault();
    this.setState({ confirm: true })
  }

  renderScaleLegend() {
    return (
      <div className="pn-legend">
        <span style={{ fontWeight: 500, color: "#334155" }}>Skala:</span>
        {SCALE_OPTIONS.map((opt) => (
          <span key={opt.value} className="pn-legend-pill" style={{ color: SCALE_STYLES[opt.value].text }}>
            <span className="pn-legend-dot" style={{ backgroundColor: SCALE_STYLES[opt.value].dot }} />
            {opt.value} {opt.label}
          </span>
        ))}
      </div>
    );
  }

  renderTabs() {
    const { activeTab } = this.state;
    return (
      <div className="pn-card" style={{ padding: "1rem", display: "flex", flexWrap: "wrap", gap: "0.75rem" }}>
        { this.state.groups.map((g, i) => {
           return (
             <>
                { this.state.canSubmit ? <>
                   <button
                      key={i}
                      type="button"
                      // onClick={() => this.setTab(g.type_name)}
                      className={`pn-tab-btn ${activeTab === g.type_name ? "pn-tab-active" : "pn-tab-inactive"}`}
                    >
                      {g.type_name}
                      <span className={`pn-tab-count ${activeTab === g.type_name ? "pn-tab-count-on" : "pn-tab-count-off"}`}>{g.total}</span>
                    </button>
                </> : <>
                     <button
                      key={i}
                      type="button"
                      onClick={() => this.setTab(g.type_name)}
                      className={`pn-tab-btn ${activeTab === g.type_name ? "pn-tab-active" : "pn-tab-inactive"}`}
                    >
                      {g.type_name}
                      <span className={`pn-tab-count ${activeTab === g.type_name ? "pn-tab-count-on" : "pn-tab-count-off"}`}>{g.total}</span>
                    </button>
                </> }
             </>
           )
            }) }
      </div>
    );
  }

   confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

  selectCategory = (e, uuid) => {
    this.setState({ competence_uuid: uuid })
  }

  renderSidebar() {
    return (
      <aside className="pn-sidebar">
        {this.state.categories.filter((x)=> x.competence_type_name === this.state.activeTab).map((cat, i) => (
          <>
             { this.state.canSubmit ? <>
                <div  key={cat.name} className={cat.competence_uuid === this.state.competence_uuid ? 'pn-cat-item  pn-active' : 'pn-cat-item'}> 
                  { this.getTotalPendingAnswerByCompetence(cat.competence_uuid) === 0 ? <>
                    <span className={'pn-cat-icon'}>
                      <FeatherIcon icon={'check-circle'} size="20" />
                    </span>
                    <div>
                      <p className="pn-cat-name">{cat.name}</p>
                      <p className="pn-cat-status">{'Selesai'}</p>
                    </div>
                  </> : <>
                    <span className={'pn-cat-icon bg-danger'}>
                      <FeatherIcon icon={'clock'} size="20" />
                    </span>
                    <div>
                      <p className="pn-cat-name">{cat.name}</p>
                      <p className="pn-cat-status">{'Menunggu'}</p>
                    </div>
                  </> }
              </div>
             </> : <>
                 <div onClick={() => this.setSidebar(cat.competence_uuid, i, cat.competence_type_name)}  key={cat.name} className={cat.competence_uuid === this.state.competence_uuid ? 'pn-cat-item  pn-active' : 'pn-cat-item'}> 
                  { this.getTotalPendingAnswerByCompetence(cat.competence_uuid) === 0 ? <>
                    <span className={'pn-cat-icon'}>
                      <FeatherIcon icon={'check-circle'} size="20" />
                    </span>
                    <div>
                      <p className="pn-cat-name">{cat.name}</p>
                      <p className="pn-cat-status">{'Selesai'}</p>
                    </div>
                  </> : <>
                    <span className={'pn-cat-icon bg-danger'}>
                      <FeatherIcon icon={'clock'} size="20" />
                    </span>
                    <div>
                      <p className="pn-cat-name">{cat.name}</p>
                      <p className="pn-cat-status">{'Menunggu'}</p>
                    </div>
                  </> }
              </div>     
             </> }
          </>
        ))}
      </aside>
    );
  }

  submitData = async () => {

    const items = this.state.questions.map((x) => {
       return {
           uuid: x.id,
           question_uuid: x.question_uuid,
           question_value: x.answer ?? 0
       }
    })

    const queryParams = new URLSearchParams(window.location.search);
    const userdata = JSON.parse(localStorage.getItem("userdata"));
    const uuid = queryParams.get('uuid')

    const formSubmit = {
        // work_unit_uuid: userdata?.employee_current_work_unit_uuid,
        team_uuid: uuid,
        evaluator_uuid: this.state.evaluator?.employee_uuid,
        evalutaee_uuid: this.state.evaluatee?.employee_uuid,
        items: items
    }
    
    await this.penialianBloc.fetchSubmitFinish(formSubmit)  
  };


  handleProgBack = () => {

    const steps = this.state.steps;
    const currentStep = this.state.currentStep;
    const nextStep = parseInt(currentStep) - 1;

    if(steps[nextStep] !== undefined){
        const obj = steps[nextStep];
        this.setState({
          currentStep: nextStep,
          competence_uuid: obj?.competence_uuid,
          activeTab: obj?.competence_type_name
        })
    }

     return

  }

  getTotalPendingAnswer = () => {

    const steps = this.state.steps;
    const currentStep = this.state.currentStep;

    if(steps[currentStep] !== undefined){
        const obj = steps[currentStep];      
        const totalAnswer = this.state.questions.filter((x) => 
          x.competence_uuid === obj?.competence_uuid && x.type_name === this.state.activeTab && parseInt(x.answer) === 0
        )
        return totalAnswer.length
    }

    return 0
  }

  getTotalPendingAnswerByCompetence = (competence_uuid) => {
    const totalAnswer = this.state.questions.filter((x) => 
      x.competence_uuid === competence_uuid && x.type_name === this.state.activeTab && parseInt(x.answer) === 0
    )
    return totalAnswer.length
  }

  handleProgNext = () => {

    const steps = this.state.steps;
    const currentStep = this.state.currentStep;
    const nextStep = parseInt(currentStep) + 1;

    if(steps[nextStep] !== undefined){
        const obj = steps[nextStep];      
        this.setState({
          currentStep: nextStep,
          competence_uuid: obj?.competence_uuid,
          activeTab: obj?.competence_type_name
        })
    }

     return
  }



  renderQuestions() {
    return (
      <div className="pn-questions">
        {this.state.questions.filter((x)=> x.type_name === this.state.activeTab && x.competence_uuid === this.state.competence_uuid ).map((question, i) => (
          <article
            key={question.id}
            disabled={!this.state.canSubmit}
            className={`pn-question-card ${question.answer !== 0 ? "pn-question-card-answered" : ""}`}
          >
            <div className="pn-question-head">
              <span className="pn-question-num">{(i+1)}</span>
              <div>
                 <h5>{question.title}</h5>
                <p className="pn-question-subtitle">{question.subtitle}</p>
              </div>
            </div>

            <div className="pn-scale-grid">
              {SCALE_OPTIONS.map((opt) => {
                const selected = question.answer === opt.value;
                const style = selected
                  ? {
                      backgroundColor: SCALE_STYLES[opt.value].bg,
                      borderColor: SCALE_STYLES[opt.value].border,
                      color: SCALE_STYLES[opt.value].text,
                      boxShadow: "0 1px 2px 0 rgba(0,0,0,0.05)",
                    }
                  : undefined;
                return (
                  <button
                    key={opt.value}
                    type="button"
                    disabled={!this.state.canSubmit}
                    onClick={() => this.selectAnswer(question.id, opt.value)}
                    className="pn-scale-option"
                    style={style}
                  >
                    <span className="pn-scale-option-value">{opt.value}</span>
                    <span className="pn-scale-option-short">{opt.short}</span>
                  </button>
                );
              })}
            </div>
          </article>
        ))}
      </div>
    );
  }

  

   loadData = async () => {
    const userdata = JSON.parse(localStorage.getItem("userdata"));
    const queryParams = new URLSearchParams(window.location.search);
    const uuid = queryParams.get('uuid')
    const evaluatee_uuid = queryParams.get('evaluatee_uuid')
    await this.penialianBloc.fetchPenilaianComponent({ uuid: uuid, employee_uuid: userdata?.employee_uuid, evaluatee_uuid: evaluatee_uuid, work_unit_uuid: userdata?.employee_current_work_unit_uuid });
  }

  componentDidMount() {

      this.loadData()

      this.penialianBloc.penilaianComponentChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingContent: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingContent: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    const categoryResponse = response.categories;
                    const periode = response.period;
                    const startDate = periode.ms360_period_date_start;
                    const endDate = periode.ms360_period_date_end;
                    const today = moment().startOf('day');
                    const start = moment(startDate).startOf('day');
                    const end = moment(endDate).endOf('day');
                    const isInRange = today.isBetween(start, end, undefined, '[]');

                    let responseQuestion = response.questions

                    if (localStorage.getItem(`session-${response.member?.ms360_team_member_uuid}`) !== null) {
                        responseQuestion = JSON.parse(localStorage.getItem(`session-${response.member?.ms360_team_member_uuid}`))
                    }

                    this.setState({
                        canSubmit: isInRange,
                        loadingContent: false,
                        member: response.member,
                        period: response.period,
                        evaluator: response.evaluator,
                        evaluatee: response.evaluatee,
                        total_question: response.total_question,
                        categories: response.categories,
                        questions: responseQuestion,
                        groups: response.groups,
                        activeTab: response.groups[0]?.type_name,
                        competence_uuid: categoryResponse[0]?.competence_uuid,
                        totalSteps: responseQuestion.length,
                        steps: response.steps
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

      this.penialianBloc.penilaianDraftChannel.subscribe((result) => {
            switch (result.status) {
                 case apiResponse.INITIAL:
                    this.setState({
                        loadingTemp: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTemp: true
                    })
                    break
                case apiResponse.COMPLETED:
                   this.setState({
                        loadingTemp: false
                    })
                    break
                case apiResponse.ERROR:
                   this.setState({
                        loadingTemp: false
                    })
                    break
                default:
                    break
            }
        })

        this.penialianBloc.penilaianFinishChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    setTimeout(() => { 
                      const storageKey = `session-${this.state.member?.ms360_team_member_uuid}`;
                      if (localStorage.getItem(storageKey) !== null) {
                        localStorage.removeItem(storageKey);
                      }
                      this.setState({
                        redirectBack: true
                      })
                    } , 750)
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

  }

  componentWillUnmount(){
     this.penialianBloc.penilaianComponentChannel.unsubscribe()
     this.penialianBloc.penilaianDraftChannel.unsubscribe()
     this.penialianBloc.penilaianFinishChannel.unsubscribe()
  }

  render() {
    const { importLoading } = this.state;
    const queryParams = new URLSearchParams(window.location.search);
    const uuid = queryParams.get('uuid')
    const userdata = JSON.parse(localStorage.getItem("userdata"));
    return (
      <Fragment>
         { this.state.loadingContent ? <>
            <div className='card'>
                <div className='card-body p-5 text-center'>
                    <Spinner size="sm" className="me-1" />
                    Memuat Data...
                </div>
            </div>
         </> : <>
             <div className="pn-page">
                <Container fluid className="pn-stack" style={{ maxWidth: "100%" }}>
                {/* Header card */}
                <section className="pn-card">
                    <div className="clearfix">
                        <div className="float-start">
                          <h1 className="pn-title">Detail Penilaian Pegawai</h1>
                          <p className="text-muted mt-2">
                            {userdata?.employee_current_work_unit_name} ({`Periode : ${moment(this.state.period.ms360_period_date_start).format('DD MMMM YYYY')} s/d ${moment(this.state.period.ms360_period_date_end).format('DD MMMM YYYY')}`})
                          </p>
                          <p className="pn-subtitle">
                              Berikan penilaian terhadap kompetensi rekan kerja secara objektif berdasarkan interaksi dan pengalaman
                              kerja
                          </p>
                        </div>
                        <div className="float-end">
                          <Button type="button" onClick={this.handleBack} className="pn-btn-outline btn-danger">
                            <FeatherIcon icon="arrow-left" size="16" />
                              <span className="ms-2">Kembali</span>
                          </Button>
                        </div>
                    </div>
                    

                    <div className="pn-divider" />

                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: "0.75rem" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                        <p className="pn-subtitle" style={{ margin: 0 }}>
                        Menilai : <span style={{ fontWeight: 600, color: "#0f172a" }}>{this.state.evaluatee?.employee_full_name}</span> - {this.state.evaluatee?.employee_current_position_name}
                        </p>
                    </div>


                    </div>

                    {/* Progress */}
                    <div style={{ marginTop: "1.25rem" }}>
                    <div className="pn-progress-track">
                        <div className="pn-progress-fill" style={{ width: `${this.progressPct}%` }} />
                    </div>
                    <div className="pn-progress-row">
                        <span className="pn-muted">
                        {this.answeredCount} dari {this.state.total_question} pertanyaan terjawab
                        </span>
                        <span style={{ fontWeight: 600, color: "#0f172a" }}>{this.progressPct} %</span>
                    </div>
                    </div>

                    {this.renderScaleLegend()}
                </section>

                {/* Tabs */}
                {this.renderTabs()}

                {/* Body: sidebar + questions, always inline side-by-side */}
                <section className="pn-body">
                    {this.renderSidebar()}
                    {this.renderQuestions()}
                </section>

                <div className="card">
                  <div className="card-body">
                     <div className="clearfix">
                      <div className="float-start">
                        {this.state.currentStep > 0 && (
                          <Button
                            type="button"
                            onClick={this.handleProgBack}
                            className="me-2"
                            color="secondary"
                          >
                            <FeatherIcon
                              icon="arrow-left"
                              size="16"
                            />

                            <span className="ms-2">
                              Sebelumnya
                            </span>
                          </Button>
                        )}
                      </div>
                      <div className="float-end">
                        {this.state.currentStep === this.state.steps.length - 1 ? (
                          <>
                            { this.state.canSubmit ? <>
                            
                            <Button
                              type="button"
                              onClick={this.handleSend}
                              disabled={
                                importLoading ||
                                parseFloat(this.progressPct) !== 100
                              }
                              className="pn-btn-submit"
                              color={this.state.loadingTemp ? 'danger' : "success"}
                            >
                              

                              { this.state.loadingTemp ? <>
                                  <Spinner size="sm" className="me-2" />
                                  <span>
                                    Menyimpan....
                                  </span>
                              </> : <> 
                              
                                <span className="me-2">
                                    Simpan dan Kirim
                                  </span>

                                  <FeatherIcon
                                    icon="send"
                                    size="16"
                                  />

                              </> } 

                            </Button>
                            
                            </> : <></> }
                          </>
                        ) : (
                          <Fragment>
                          <Button
                            type="button"
                            onClick={this.handleProgNext}
                            disabled={parseInt(this.getTotalPendingAnswer()) > 0}
                            color={this.state.loadingTemp ? 'danger' : "secondary"}
                          >

                            

                            { this.state.loadingTemp ? <>
                                <Spinner size="sm" className="me-2" />
                                <span>
                                  Menyimpan....
                                </span>
                            </> : <> 
                                <span className="me-2">
                                  Selanjutnya
                                </span>
                                <FeatherIcon
                                  icon="arrow-right"
                                  size="16"
                                />
                            </> } 

                           

                          </Button>
                          </Fragment>
                        )}
                      </div>
                    </div>       
                  </div>
                </div>

                
               
                </Container>
            </div>
         </> }
         { this.state.redirectBack ?
            <Redirect to={`/kepegawaian/penialian360.html?section=detail&uuid=${uuid}`} />
        : null }
        <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={"Apakah anda yakin data tersebut sudah benar?"}
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo={'Data berhasil diperbaharui'}
            failedTitle="Gagal!"
            failedInfo="Data gagal disimpan"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}



export default PenialianPegawaiDetailComponent;